<template>
    <div class="system-dash-wrapper agent-dash">

    <div v-if="dpcards" class="top-count-row">
        <div @click="navigateToTcktng" class="box-wrapper c-pointer">
            <div class="top">
                <div class="left">
                    <div class="icon">
                        <img src="@imgPath/img/svg/icons/ticketing_queue.svg" alt="">
                    </div>
                    <div class="name-t">
                        {{$t('dashBoard.cDPtopCards.ticktQue')}}
                    </div>
                </div>
                <div class="right">
                    <div class="number">
                        <div v-c-tooltip.hover="{ content: dpcards.ticketingqueue + ' '+$t('dashBoard.cDPtopCards.ticktQue') , active:false }">
                            {{dpcards.ticketingqueue}}
                        </div>
                    </div>
                </div>


            </div>
            <div class="bottom">
                <div class="progressbar">
                    <CProgress
                            class="progress-sm mt-2"
                            :precision="1"
                            color="info"
                            :value="50"
                    />

                </div>
            </div>
        </div>
        <div @click="navigateToBookings" class="box-wrapper c-pointer">
            <div class="top">
                <div class="left">
                    <div class="icon">
                        <img src="@imgPath/img/svg/icons/issued_tickets.svg" alt="">
                    </div>
                    <div class="name-t">
                        {{$t('dashBoard.cDPtopCards.issuedTickets')}}
                    </div>
                </div>
                <div class="right flex-flow-column">
                    <div class="number"> <div v-c-tooltip.hover="{ content: dpcards.issuedbookingstoday + ' ' + $t('dashBoard.cDPtopCards.issuedTicketsToday') , active:false }">
                        {{dpcards.issuedbookingstoday}}
                    </div> </div>
                    <div class="number"> <div v-c-tooltip.hover="{ content: dpcards.issuedbookingsmonth + ' ' + $t('dashBoard.cDPtopCards.issuedTicketsInThisMonth') , active:false }">
                        {{dpcards.issuedbookingsmonth}}
                    </div> </div>
                </div>


            </div>
            <div class="bottom">
                <div class="progressbar">
                    <CProgress
                            class="progress-sm mt-2"
                            :precision="1"
                            color="green"
                            :value="50"
                    />
                </div>
            </div>
        </div>
        <div class="box-wrapper c-pointer" v-if="userLogoDetail"  @click="userLogoDetail.agenttype==1?navigateToTopUp():navigateToDeposit()">
            <div class="top flex-flow-column">
                <div class="left ">
<!--                    <div class="icon">-->
<!--                        <img src="@imgPath/img/svg/icons/euro.svg" alt="">-->
<!--                    </div>-->
                    <div class="name-t pt-0" v-if="userLogoDetail.agenttype==1">
               <span>
                   <img class="icon-avai" src="@imgPath/img/svg/icons/credit_avai.svg" alt="">
               </span>       {{ $t('dashBoard.cDPtopCards.availableLimit')}}
                    </div>
                    <div class="name-t pt-0" v-if="userLogoDetail.agenttype==2">
                       <span>
                   <img class="icon-avai" src="@imgPath/img/svg/icons/credit_avai.svg" alt="">
               </span>    {{ $t('dashBoard.cDPtopCards.availableLimit')}}
                    </div>
                </div>
                <div class="right center-divd" >
                    <div class="number" v-for="(finance, index) in balDet" :key="index" >
                        <span v-if="finance.agenttype==agentType.prepaid && finance.prepaidbalance" class="d-flex flex-flow-column">
                       <span>
                            {{finance.currecycode}}
                       </span>
                            <span>
                                {{finance.prepaidbalance | formatNumber(finance.currecycode)}}
                            </span>
                        </span>
                        <span v-if="finance.agenttype==agentType.postpaid && finance.postpaid_runningamount" class="d-flex flex-flow-column">
                            <span>
                                 {{finance.currecycode}}
                            </span>
                            <span>
                                {{getPostPaidAmt(finance.postpaidlimit,finance.postpaid_runningamount)|
                        formatNumber(finance.currecycode)}}
                            </span>
                        </span>
                    </div>

                </div>


            </div>
            <div class="bottom">

                <span class="label-sub-title">
                    <span  v-if="userLogoDetail.agenttype==1">
                    {{ $t('dashBoard.cDPtopCards.topUp')}}
                    </span>
                      <span v-if="userLogoDetail.agenttype==2">
                        {{ $t('dashBoard.cDPtopCards.payStatement')}}
                     </span>
            </span>

            </div>
        </div>



    </div>

    </div>
  

</template>
<script>

    import Logger from "../../services/logger";
    import {VALIDATE_SUCCESS_RES, getErrorMessage} from "@/util/apiValidate.js";
    import router, {navigate, goBack} from "../../router/index";
    import apiGetBookingNumber from "./../../services/apiGetBookingNumber";
    import apiGetBalanceDetail from "./../../services/apiGetBalanceDetail";
    import {
        LOG_TYPE,
        FILE_NAME,
    } from "../../config/API_DATA";
    import {COMPONENT_NAME, PATHNAME, APPROVEAGENT} from "../../util/constants";
    import BaseConfiguration from "../../config/base.js";
    import {mapGetters, mapActions} from "vuex";
    import {handleJWT, getErrorAlertValue, parseNumber} from "../../util/util";

    export default {
        name: COMPONENT_NAME.C_DP_TOP_CARDS,

        data: () => {
            return {
                dpcards: null,
                balDet: [],
                agentType: {
                    prepaid: APPROVEAGENT.PREPAID,
                    postpaid: APPROVEAGENT.POSTPAID
                }
            };
        },
        computed: {
            ...mapGetters("sDashBoard", {
                userLogoDetail: "GET_AGENT_LOGO_DET_RES",
            }),
            ...mapGetters('sAgtLogin', {GET_SIGNIN_RES: 'GET_SIGNIN_RES'})

        },

        props: {},
        async created() {
            if (BaseConfiguration.isDebug) console.log("created");
            try {
                if (this.userLogoDetail && this.userLogoDetail.b2bid && this.GET_SIGNIN_RES) {
                    this.dpcards = await this.getBookingNumber();
                    //   this.dpcards.ticketingqueue = bookingNoRes.ticketingqueue;
                    //   this.dpcards.issuedTckts+=  bookingNoRes.issued_percentageincrease!=null? parseInt(bookingNoRes.issued_percentageincrease) : 0
                    // this.dpcards.issuedTckts+=  bookingNoRes.issuedbookingsmonth !=null? parseInt(bookingNoRes.issuedbookingsmonth): 0
                    //  this.dpcards.issuedTckts+=  bookingNoRes.issuedbookingstoday !=null? parseInt(bookingNoRes.issuedbookingstoday): 0
                    this.balDet = await this.getBalanceDetail(this.userLogoDetail.b2bid ? this.userLogoDetail.b2bid : null);

                }
            } catch (err) {
                let body = Logger.buildRequest(
                    COMPONENT_NAME.C_DP_TOP_CARDS,
                    "error in  Created",
                    err.toString(),
                    " Created()",
                    LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
            }
        },

        methods: {
            ...mapActions("sDashBoard", {

                SET_AGENT_FINANCE_RESPONSE: "SET_AGENT_FINANCE_RESPONSE"
            }),

            navigateToTcktng() {
                let retValue;
                try {
                  if(BaseConfiguration.isDebug) console.log("navigateToTcktng");
                  navigate(PATHNAME.TICKETING_QUEUE);
            
                } catch (err) {
                        let body = Logger.buildRequest(
                          COMPONENT_NAME.C_DP_TOP_CARDS,
                          "error in navigateToTcktng",
                          err.toString(),
                          "navigateToTcktng",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                  return retValue;
            },

            navigateToBookings() {
                let retValue;
                try {
                  if(BaseConfiguration.isDebug) console.log("navigateToBookings");
                  navigate(PATHNAME.MY_BOOKING);
            
                } catch (err) {
                        let body = Logger.buildRequest(
                          COMPONENT_NAME.C_DP_TOP_CARDS,
                          "error in navigateToBookings",
                          err.toString(),
                          "navigateToBookings",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                  return retValue;
            },

            navigateToTopUp() {
             
                try {
                  if(BaseConfiguration.isDebug) console.log("navigateToTopUp");
                  navigate(PATHNAME.TOPUP);
            
                } catch (err) {
                        let body = Logger.buildRequest(
                          COMPONENT_NAME.C_DP_TOP_CARDS,
                          "error in navigateToTopUp",
                          err.toString(),
                          "navigateToTopUp",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                  
            },
            
            navigateToDeposit() {
              
                try {
                  if(BaseConfiguration.isDebug) console.log("navigateToDeposit");
                  navigate(PATHNAME.AGENT_DEPOSIT);
            
                } catch (err) {
                        let body = Logger.buildRequest(
                          COMPONENT_NAME.C_DP_TOP_CARDS,
                          "error in navigateToDeposit",
                          err.toString(),
                          "navigateToDeposit",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                 
            },

            getPostPaidAmt(pPostPaidLimit, pPostPaidRunAmt) {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("getPostPaidAmt");

                    retValue = parseNumber(pPostPaidLimit) - parseNumber(pPostPaidRunAmt);


                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_DP_TOP_CARDS,
                        "error in getPostPaidAmt",
                        err.toString(),
                        "getPostPaidAmt",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            showAlert(val) {
                this.$emit("showAlert", val);
            },

            async getBalanceDetail(pB2bid) {
                let returnValue;
                try {
                    let balanceReq = apiGetBalanceDetail.buildRequest(pB2bid);
                    if (balanceReq) {
                        let balanceRes = await apiGetBalanceDetail.getResponse(balanceReq);
                        if (VALIDATE_SUCCESS_RES(balanceRes)) {
                            returnValue = balanceRes.data.data;
                            this.SET_AGENT_FINANCE_RESPONSE(returnValue);
                        } else {
                            let error = getErrorMessage(balanceRes);
                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                this.showAlert(getErrorAlertValue(error));
                            }
                        }
                    } else {
                        throw "invalid request";
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_DP_TOP_CARDS,
                        "error in  getBalanceDetail",
                        err.toString(),
                        " getBalanceDetail()",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return returnValue;
            },


            async getBookingNumber() {
                if (BaseConfiguration.isDebug) console.log("getBookingNumber");
                let returnValue;
                try {
                    let getBookingNumberReq = apiGetBookingNumber.buildRequest(); //constant

                    if (getBookingNumberReq != null) {
                        let getBookingNumberRes = await apiGetBookingNumber.getResponse(
                            getBookingNumberReq
                        );
                        if (VALIDATE_SUCCESS_RES(getBookingNumberRes)) {
                            returnValue = getBookingNumberRes.data.data;

                        } else {
                            let error = getErrorMessage(getBookingNumberRes);

                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                this.showAlert(getErrorAlertValue(error));
                            }
                        }
                    } else {
                        throw "invalid request";
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_DP_TOP_CARDS,
                        "error in  getBookingNumber",
                        err.toString(),
                        "getBookingNumber()",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return returnValue;
            },
        }
    }
</script>